import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelyRenaultMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="renaultGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#FFCC00", stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: "#FFB400", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#2C2C2C", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <rect width={width} height={height} fill="url(#renaultGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {Array.from({ length: 14 }).map((_, layer) => {
          const size = 80 + layer * 35;
          const angle = (layer * 15) % 360;
          return (
            <rect
              key={`motion-${layer}`}
              x={-size / 2}
              y={-size / 2}
              width={size}
              height={size}
              fill="none"
              stroke="#FFCC00"
              strokeWidth={2}
              opacity={0.25 - layer * 0.012}
              transform={`rotate(${angle})`}
            />
          );
        })}
        {Array.from({ length: 18 }).map((_, r) => (
          <circle
            key={`kinetic-${r}`}
            cx={0}
            cy={0}
            r={(r + 1) * 22}
            fill="none"
            stroke="#FFFFFF"
            strokeWidth={r % 3 === 0 ? 2.5 : 1.5}
            opacity={0.3 - r * 0.012}
          />
        ))}
        <circle cx={0} cy={0} r={50} fill="none" stroke="#FFCC00" strokeWidth={3} opacity={0.6} />
        <circle cx={0} cy={0} r={35} fill="#FFB400" opacity={0.4} />
      </g>
    </svg>
  );
};
